module.exports = __webpack_public_path__ + "img/crystal-palace.bbdd414f.png";